import { ExtensibilityModeEnum } from 'owa-addins-types';
import { getAdapter, MessageReadAdapter } from 'owa-addins-apis';
import { getPreviousNavigationState } from './PreviousNavigationState';
import { shouldAddinsActivate } from 'owa-addins-store';

export function doesItemSupportAddins(hostItemIndex: string): boolean {
    const adapter = getAdapter(hostItemIndex);
    const mode = adapter.mode;

    if (mode === ExtensibilityModeEnum.MessageRead) {
        return shouldAddinsActivate((adapter as MessageReadAdapter).getItem());
    }
    return true;
}

export function isItemPartSelected(hostItemIndex: string): boolean {
    const adapter = getAdapter(hostItemIndex);
    const mode = adapter.mode;

    if (mode === ExtensibilityModeEnum.MessageRead) {
        return (adapter as MessageReadAdapter).isItemSelected();
    }
    return true;
}

export function isInlineComposeOpen(hostItemIndex: string): boolean {
    const adapter = getAdapter(hostItemIndex);
    const mode = adapter.mode;

    if (mode === ExtensibilityModeEnum.MessageRead) {
        return (adapter as MessageReadAdapter).isInlineComposeOpen();
    }
    return false;
}

export function isEventDuplicate(hostItemIndex: string): boolean {
    return hostItemIndex === getPreviousNavigationState().hostItemIndex;
}

export function isModeChanged(hostItemIndex: string): boolean {
    return getMode(hostItemIndex) !== getPreviousNavigationState().mode;
}

export function getMode(hostItemIndex: string): ExtensibilityModeEnum {
    switch (getAdapter(hostItemIndex).mode) {
        case ExtensibilityModeEnum.MessageRead:
        case ExtensibilityModeEnum.MeetingRequest:
            return ExtensibilityModeEnum.MessageRead;
        case ExtensibilityModeEnum.MessageCompose:
            return ExtensibilityModeEnum.MessageCompose;
        default:
            return ExtensibilityModeEnum.Unknown;
    }
}
